export default __webpack_public_path__ + "static/media/chery_aftersales_card.7c453b0e.png";